import React from "react";
import { BestLink } from "best-common-react";

function TicketmasterLinkFormatter(props) {
  const { gamePk } = props.value;
  const to = `/admin/${gamePk}/ticketmaster`;

  return (
    <BestLink to={to}>
      <div>View for {gamePk}</div>
    </BestLink>
  );
}

export default TicketmasterLinkFormatter;
